export enum MmRoutesEnum {
    customers = 'customers',
    projects = 'projects',
    projects_overview = ':customerId/projects-overview',
    faults = ':projectId/faults',
    plans = ':projectId/plans',
    co_plans = ':projectId/configurations/plans',
    co_bim_models = ':projectId/configurations/bim-models',
    co_structures = ':projectId/configurations/structures',
    co_bim_sections = ':projectId/configurations/bim-sections',
    user_variables = ':projectId/configurations/user/variables',
    capacitor_app_setting = ':projectId/configurations/capacitor-app-setting',
    project_companies = ':projectId/configurations/companies',
    project_crafts  = ':projectId/configurations/crafts',
    project_variables = ':projectId/configurations/variables',
    project_type1 = ':projectId/configurations/userdefineds/type1',
    project_type2 = ':projectId/configurations/userdefineds/type2',
    project_informations = ':projectId/configurations/informations',
    access_denied = 'access_denied',
    costs = 'customers/:customerId/costs',
    costs_invoices = 'customers/:customerId/costs/invoices',
    costs_timeTracking = 'customers/:customerId/costs/time-tracking',
    project_settings = ':projectId/configurations/settings',
}
